import { render, staticRenderFns } from "./RedeemProducts.vue?vue&type=template&id=1b01bd72"
import script from "./RedeemProducts.vue?vue&type=script&lang=js"
export * from "./RedeemProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports